import React from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Link, useNavigate } from 'react-router-dom';
export function SectionQuestions() {
  const navigate = useNavigate();
  const questions = [{
    id: 101,
    question: 'What is the primary water source for desert flora?',
    answer: 'yes',
    section: 'Section 1',
    course: 'Desert Ecology Basics',
    created: '2023-01-15',
    modified: '2023-06-20'
  }, {
    id: 102,
    question: 'Does the Saguaro cactus grow in the Mojave desert?',
    answer: 'no',
    section: 'Section 2',
    course: 'Desert Ecology Basics',
    created: '2023-01-16',
    modified: '2023-01-16'
  }, {
    id: 103,
    question: 'Is drip irrigation more efficient than sprinklers?',
    answer: 'yes',
    section: 'Section 1',
    course: 'Sustainable Landscaping',
    created: '2023-02-10',
    modified: '2023-08-05'
  }];
  return <div className="space-y-4" data-id="element-1562" data-mp="3jb7cbmrt9maw">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1563" data-mp="3nay2ppdfe0ew">Section Questions</h1>

      {/* Filters */}
      <div className="space-y-2" data-id="element-1564" data-mp="3saaxqxegadsk">
        <div data-id="element-1565" data-mp="3s8zssu99qzzv">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1566" data-mp="3s8hqpgzxdrk1">Course</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[200px]" data-id="element-1567" data-mp="wexai6fhvkk">
            <option value="" data-id="element-1568" data-mp="atjahsiaqgp8">All Courses</option>
            <option value="1" data-id="element-1569" data-mp="as87vw0l7ezp">Desert Ecology Basics</option>
            <option value="2" data-id="element-1570" data-mp="evebevwbes2h">Advanced Water Conservation</option>
          </select>
        </div>
        <div data-id="element-1571" data-mp="jtzc0wfhbdrg">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1572" data-mp="jur808czndi9">Section</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[140px]" data-id="element-1573" data-mp="2gmj31ry8zsmt">
            <option value="" data-id="element-1574" data-mp="2lm4a6pnkn7am">All Sections</option>
            <option value="1" data-id="element-1575" data-mp="3ow8blez4q3k0">Section 1</option>
            <option value="2" data-id="element-1576" data-mp="3ox1mms54ff7y">Section 2</option>
          </select>
        </div>
        <div className="flex items-center gap-4" data-id="element-1577" data-mp="3jygm0rlyitiz">
          <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1578" data-mp="3jzrqyur527bo">
            Search
          </Button>
          <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/questions/add')} data-id="element-1579" data-mp="bp6lo43gx6ps">
            <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-1580" data-mp="kk4ivndnf5mx" />
            Add
          </Button>
        </div>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1581" data-mp="ug7tziqhaem0">
        <div className="overflow-x-auto" data-id="element-1582" data-mp="ued6bwnto8e8">
          <table className="w-full text-sm text-left" data-id="element-1583" data-mp="pi61y8b2r4ye">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1584" data-mp="pfjus9s3irgp">
              <tr data-id="element-1585" data-mp="193ps1y9jcazg">
                <th className="px-3 py-3 border-r border-slate-700 text-center w-16" data-id="element-1586" data-mp="1913lo1yds1it">
                  Id
                </th>
                <th className="px-4 py-3 border-r border-slate-700" data-id="element-1587" data-mp="z58yctj7pi9p">
                  Question
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1588" data-mp="143k52ve7ncnp">
                  Answer
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-24" data-id="element-1589" data-mp="qb40vr9kp8l7">
                  Section
                </th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1590" data-mp="v5hz01fmdttk">Course</th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1591" data-mp="gg2bcubdy4i3">
                  Created
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1592" data-mp="lb97nh2bs6wz">
                  Modified
                </th>
                <th className="px-4 py-3 text-center w-32" data-id="element-1593" data-mp="bfo0z5mbaigw">
                  <div data-id="element-1594" data-mp="bh8v4u4prze8">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1595" data-mp="4chjcj2z869l">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1596" data-mp="3qr0wydk4nhf0">
              {questions.map(q => <tr key={q.id} className="hover:bg-slate-50" data-id="element-1597" data-mp="3lthjvgz61aon">
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1598" data-mp="3lqvbjf4gar5d">
                    {q.id}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-1599" data-mp="3crrt8dd3yfrx">
                    {q.question}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center capitalize" data-id="element-1600" data-mp="37tgje2mtc59p">
                    {q.answer}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1601" data-mp="161bjo4z2o3of">
                    <Link to="#" className="text-blue-600 hover:underline" data-id="element-1602" data-mp="15zh6xdxyfhvf">
                      {q.section}
                    </Link>
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1603" data-mp="19ig43cs2rtx6">
                    <Link to="#" className="text-blue-600 hover:underline" data-id="element-1604" data-mp="1dkksnx3o20cy">
                      {q.course}
                    </Link>
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1605" data-mp="1idw3087osz9m">
                    {q.created}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1606" data-mp="ql53noupiug5">
                    {q.modified}
                  </td>
                  <td className="px-4 py-2.5 text-center" data-id="element-1607" data-mp="umqmrrxu44ys">
                    <div className="flex items-center justify-center gap-2" data-id="element-1608" data-mp="zks4o9jixy8o">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/questions/view/${q.id}`)} data-id="element-1609" data-mp="14keiak39lgi0">
                        <Eye className="h-4 w-4" data-id="element-1610" data-mp="2fyidtupi3cp6" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/questions/edit/${q.id}`)} data-id="element-1611" data-mp="1qawby1pzbyjm">
                        <Edit className="h-4 w-4" data-id="element-1612" data-mp="208u24ureg5ev" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1613" data-mp="1vbtvahmq6ymp">
                        <Trash2 className="h-4 w-4" data-id="element-1614" data-mp="12md5zsuejxup" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-1615" data-mp="1cj973dhz1hp8">
        <button className="hover:underline" data-id="element-1616" data-mp="otn8os9fb6ia">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-1617" data-mp="jvdd4gjse3w5">|</span>
        <span className="text-slate-900 font-medium" data-id="element-1618" data-mp="jukclxbf8amg">1</span>
        <span className="text-slate-400" data-id="element-1619" data-mp="2viyxv5lle73s">|</span>
        <button className="hover:underline" data-id="element-1620" data-mp="2vh4f9xxsmr2v">2</button>
        <span className="text-slate-400" data-id="element-1621" data-mp="309xi2g9pbpcb">|</span>
        <button className="hover:underline" data-id="element-1622" data-mp="30aqg8sulh6iu">3</button>
        <span className="text-slate-400" data-id="element-1623" data-mp="2ll1bknnamkdt">|</span>
        <button className="hover:underline" data-id="element-1624" data-mp="2lmce6k505m3c">next &gt;&gt;</button>
      </div>
    </div>;
}